import {AllData} from "../../data/model/all-data-schema";
import {createContext, useContext} from "react";

const PortfolioDataContext = createContext<AllData | null>(null);

export function usePortfolioData(): AllData {
    const data = useContext(PortfolioDataContext);
    if (!data) {
        throw new Error("No portfolio data provided");
    }
    return data;
}

export function PortfolioDataProvider ({ data, children }: { data: AllData, children: React.ReactNode }) {
    return <PortfolioDataContext.Provider value={data}>
        { children }
    </PortfolioDataContext.Provider>
}